module.exports = __webpack_public_path__ + "img/icon6.e3028356.svg";